import type { Address } from 'viem';

import { queryClient } from 'clients/api/queryClient';
import FunctionKey from 'constants/functionKey';

// Shared TanStack cache-bust for the six useRouter*Queue hooks. The optional
// `tokenAddress` / `netuid` cover op-specific keys (single-ERC20 wallet
// balance, per-subnet staking allowance) and are skipped when not relevant.
// Per-vToken GET_V_TOKEN_CASH must go stale after any router op that mutates
// market liquidity — it backs the BorrowForm.exceedsLiveCash preflight.
export const invalidateRouterQueries = ({
  accountAddress,
  chainId,
  poolComptrollerAddress,
  routerAddress,
  vTokenAddresses,
  tokenAddress,
  netuid,
}: {
  accountAddress: Address;
  chainId: number;
  poolComptrollerAddress: Address;
  routerAddress: Address;
  vTokenAddresses: readonly Address[];
  tokenAddress?: Address;
  netuid?: bigint;
}): void => {
  queryClient.invalidateQueries({ queryKey: [FunctionKey.GET_POOLS] });
  queryClient.invalidateQueries({
    queryKey: [FunctionKey.GET_TOKEN_BALANCES, { chainId, accountAddress }],
  });
  if (tokenAddress !== undefined) {
    queryClient.invalidateQueries({
      queryKey: [FunctionKey.GET_BALANCE_OF, { chainId, accountAddress, tokenAddress }],
    });
  }
  for (const vTokenAddress of vTokenAddresses) {
    queryClient.invalidateQueries({
      queryKey: [FunctionKey.GET_V_TOKEN_BALANCE, { chainId, accountAddress, vTokenAddress }],
    });
    queryClient.invalidateQueries({
      queryKey: [FunctionKey.GET_V_TOKEN_CASH, { chainId, vTokenAddress }],
    });
  }
  queryClient.invalidateQueries({
    queryKey: [FunctionKey.GET_BITTENSOR_NATIVE_BALANCES],
  });
  queryClient.invalidateQueries({
    queryKey: [
      FunctionKey.GET_POOL_DELEGATE_APPROVAL_STATUS,
      {
        delegateeAddress: routerAddress,
        poolComptrollerAddress,
        accountAddress,
      },
    ],
  });
  if (netuid !== undefined) {
    queryClient.invalidateQueries({
      queryKey: [
        FunctionKey.GET_ROUTER_STAKING_ALLOWANCE,
        {
          chainId,
          accountAddress,
          routerAddress,
          netuid: netuid.toString(),
        },
      ],
    });
  }
};
